<template>
  <fragment>
    <div class="v2_font_Montserrat font_size_1000rem navigation-tabs">
      <b-nav tabs justified>
        <b-row>
          <b-col class="px-0 border-nav mb-1">
            <b-nav-item to="/recruiter" exact>
              <span class="d-flex align-items-center">
                <span>Dashboard</span>
              </span>
            </b-nav-item>
          </b-col>
          <b-col class="px-0 border-nav">
            <b-nav-item to="/recruiter/ico" exact>
              <span class="d-flex align-items-center">
                <span>Connect</span>
              </span>
            </b-nav-item>
          </b-col>
          <b-col class="px-0 border-nav">
            <b-nav-item to="/recruiter/inform" exact>
              <span class="d-flex align-items-center">
                <span>Inform</span>
              </span>
            </b-nav-item>
          </b-col>
          <!--          <b-col lg="4" md="4" cols="8" class="px-0 border-nav ">-->
          <!--            <b-nav-item to="/recruiter/exchange" exact>-->
          <!--              <span class="d-flex align-items-center">-->
          <!--                <span>Exchange</span>-->
          <!--              </span>-->
          <!--            </b-nav-item>-->
          <!--          </b-col>-->
        </b-row>
      </b-nav>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'RecruiterNavMenuItems',
};
</script>

<style scoped>
.navigation-tabs {
  padding: 0 15px;
}
.navigation-tabs .nav {
  display: unset;
}
.border-nav {
  border-right: 1px solid rgba(3, 23, 36, 0.2);
}
</style>

<style scoped lang="scss">
@import '../../../../sass/v2';
.nav-tabs {
  .nav-item {
    .nav-link {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 15px;
      height: 50px;
      background-color: $phairify_v2_color_alice_blue;
      text-transform: uppercase;
      letter-spacing: 1.4px;
      color: $phairify_v2_color_black_knight;
      border: 0;
      border-radius: 0;
      border-right: 1px solid rgba(#031724, 0.2);
      &:hover {
        border-right: 1px solid rgba(#031724, 0.2);
      }
      &.router-link-exact-active {
        background: #ffffff 0% 0% no-repeat padding-box;
        border-right: 1px solid rgba(#031724, 0.2);
      }
    }
    &:last-child {
      .nav-link {
        border-right: 0;
      }
    }
  }
}
</style>
